/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BeneficiaryDTO,
  ConfirmIntentDTO,
  CreateFeedbackDTO,
  CreateIntentDTO,
  CreateOrganizationDTO,
  CreateOrganizationQRDTO,
  CreateOrganizationWalletDTO,
  FeedbackDTO,
  GetMagicLinkDTO,
  IntentDTO,
  IntentDetailsDTO,
  IntentProviderDTO,
  InvitationCodeDTO,
  Kycdto,
  LinkDTO,
  OrgTransactionResponseDTO,
  OrgWalletControllerGetTransactionsCSVParams,
  OrgWalletControllerGetTransactionsParams,
  OrganizationByCodeDTO,
  OrganizationByInvitationDTO,
  OrganizationControllerUploadAvatarBody,
  OrganizationDTO,
  OrganizationLinksControllerGetInvitationLinkParams,
  OrganizationQRDTO,
  PageOrganizationDTO,
  PageParticipantDTO,
  PageQRDTO,
  ParticipantDTO,
  PaymentRuletDTO,
  SendInvitationDTO,
  SendReceiptDTO,
  SetPaymentRuleDTO,
  StripeConnecTokenDTO,
  StripeConnectStatusDTO,
  SuccessDTO,
  TagDTO,
  TransactionPostingDTO,
  TransactionResponseDTO,
  UpdateAttributionDTO,
  UpdateBeneficiaryDTO,
  UpdateOrganizationDTO,
  UpdateOrganizationQRDTO,
  UpdateOrganizationWalletDTO,
  UpdateParticipantDTO,
  UpdateUserDTO,
  UserBeneficiaryControllerUploadDocumentBody,
  UserControllerUploadAvatarBody,
  UserCreatePayoutDTO,
  UserDTO,
  UserParticipantDTO,
  UserPayoutDTO,
  UserWalletControllerGetTransactionsParams,
  WalletDTO
} from './models'
import { clientInstance } from '../../utils/api.fetch.client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const userControllerRequestManagerAccess = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/user/requestManagerAccess`, method: 'POST', signal
    },
      options);
    }
  


export const getUserControllerRequestManagerAccessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRequestManagerAccess>>, TError,void, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerRequestManagerAccess>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerRequestManagerAccess>>, void> = () => {
          

          return  userControllerRequestManagerAccess(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerRequestManagerAccessMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerRequestManagerAccess>>>
    
    export type UserControllerRequestManagerAccessMutationError = unknown

    export const useUserControllerRequestManagerAccess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRequestManagerAccess>>, TError,void, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userControllerRequestManagerAccess>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getUserControllerRequestManagerAccessMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userControllerMe = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<UserDTO>(
      {url: `/user/me`, method: 'GET', signal
    },
      options);
    }
  

export const getUserControllerMeQueryKey = () => {
    return [`/user/me`] as const;
    }

    
export const getUserControllerMeQueryOptions = <TData = Awaited<ReturnType<typeof userControllerMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerMe>>> = ({ signal }) => userControllerMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserControllerMeQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerMe>>>
export type UserControllerMeQueryError = unknown


export function useUserControllerMe<TData = Awaited<ReturnType<typeof userControllerMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerMe>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserControllerMe<TData = Awaited<ReturnType<typeof userControllerMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerMe>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserControllerMe<TData = Awaited<ReturnType<typeof userControllerMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserControllerMe<TData = Awaited<ReturnType<typeof userControllerMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserControllerMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userControllerAttribute = (
    updateAttributionDTO: UpdateAttributionDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/user/attribute`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAttributionDTO
    },
      options);
    }
  


export const getUserControllerAttributeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerAttribute>>, TError,{data: UpdateAttributionDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerAttribute>>, TError,{data: UpdateAttributionDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerAttribute>>, {data: UpdateAttributionDTO}> = (props) => {
          const {data} = props ?? {};

          return  userControllerAttribute(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerAttribute>>>
    export type UserControllerAttributeMutationBody = UpdateAttributionDTO
    export type UserControllerAttributeMutationError = unknown

    export const useUserControllerAttribute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerAttribute>>, TError,{data: UpdateAttributionDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userControllerAttribute>>,
        TError,
        {data: UpdateAttributionDTO},
        TContext
      > => {

      const mutationOptions = getUserControllerAttributeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userControllerUpdate = (
    updateUserDTO: UpdateUserDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<UserDTO>(
      {url: `/user`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserDTO
    },
      options);
    }
  


export const getUserControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{data: UpdateUserDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{data: UpdateUserDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdate>>, {data: UpdateUserDTO}> = (props) => {
          const {data} = props ?? {};

          return  userControllerUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdate>>>
    export type UserControllerUpdateMutationBody = UpdateUserDTO
    export type UserControllerUpdateMutationError = unknown

    export const useUserControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{data: UpdateUserDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdate>>,
        TError,
        {data: UpdateUserDTO},
        TContext
      > => {

      const mutationOptions = getUserControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userControllerUploadAvatar = (
    userControllerUploadAvatarBody: UserControllerUploadAvatarBody,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(userControllerUploadAvatarBody.file !== undefined) {
 formData.append('file', userControllerUploadAvatarBody.file)
 }

      return clientInstance<SuccessDTO>(
      {url: `/user/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getUserControllerUploadAvatarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUploadAvatar>>, TError,{data: UserControllerUploadAvatarBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUploadAvatar>>, TError,{data: UserControllerUploadAvatarBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUploadAvatar>>, {data: UserControllerUploadAvatarBody}> = (props) => {
          const {data} = props ?? {};

          return  userControllerUploadAvatar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUploadAvatar>>>
    export type UserControllerUploadAvatarMutationBody = UserControllerUploadAvatarBody
    export type UserControllerUploadAvatarMutationError = unknown

    export const useUserControllerUploadAvatar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUploadAvatar>>, TError,{data: UserControllerUploadAvatarBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUploadAvatar>>,
        TError,
        {data: UserControllerUploadAvatarBody},
        TContext
      > => {

      const mutationOptions = getUserControllerUploadAvatarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userWalletControllerGetWallet = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<WalletDTO[]>(
      {url: `/wallet`, method: 'GET', signal
    },
      options);
    }
  

export const getUserWalletControllerGetWalletQueryKey = () => {
    return [`/wallet`] as const;
    }

    
export const getUserWalletControllerGetWalletQueryOptions = <TData = Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserWalletControllerGetWalletQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userWalletControllerGetWallet>>> = ({ signal }) => userWalletControllerGetWallet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserWalletControllerGetWalletQueryResult = NonNullable<Awaited<ReturnType<typeof userWalletControllerGetWallet>>>
export type UserWalletControllerGetWalletQueryError = unknown


export function useUserWalletControllerGetWallet<TData = Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userWalletControllerGetWallet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserWalletControllerGetWallet<TData = Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userWalletControllerGetWallet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserWalletControllerGetWallet<TData = Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserWalletControllerGetWallet<TData = Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetWallet>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserWalletControllerGetWalletQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userWalletControllerGetTransactions = (
    params: UserWalletControllerGetTransactionsParams,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<TransactionResponseDTO>(
      {url: `/wallet/transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getUserWalletControllerGetTransactionsQueryKey = (params: UserWalletControllerGetTransactionsParams,) => {
    return [`/wallet/transactions`, ...(params ? [params]: [])] as const;
    }

    
export const getUserWalletControllerGetTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError = unknown>(params: UserWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserWalletControllerGetTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>> = ({ signal }) => userWalletControllerGetTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserWalletControllerGetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>>
export type UserWalletControllerGetTransactionsQueryError = unknown


export function useUserWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError = unknown>(
 params: UserWalletControllerGetTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userWalletControllerGetTransactions>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError = unknown>(
 params: UserWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userWalletControllerGetTransactions>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError = unknown>(
 params: UserWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError = unknown>(
 params: UserWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserWalletControllerGetTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userPartControllerMyParticipants = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<UserParticipantDTO[]>(
      {url: `/user/participant`, method: 'GET', signal
    },
      options);
    }
  

export const getUserPartControllerMyParticipantsQueryKey = () => {
    return [`/user/participant`] as const;
    }

    
export const getUserPartControllerMyParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserPartControllerMyParticipantsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userPartControllerMyParticipants>>> = ({ signal }) => userPartControllerMyParticipants(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserPartControllerMyParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof userPartControllerMyParticipants>>>
export type UserPartControllerMyParticipantsQueryError = unknown


export function useUserPartControllerMyParticipants<TData = Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPartControllerMyParticipants>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserPartControllerMyParticipants<TData = Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPartControllerMyParticipants>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserPartControllerMyParticipants<TData = Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserPartControllerMyParticipants<TData = Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPartControllerMyParticipants>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserPartControllerMyParticipantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userKYCControllerGetChallenges = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<Kycdto[]>(
      {url: `/user/kyc`, method: 'GET', signal
    },
      options);
    }
  

export const getUserKYCControllerGetChallengesQueryKey = () => {
    return [`/user/kyc`] as const;
    }

    
export const getUserKYCControllerGetChallengesQueryOptions = <TData = Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserKYCControllerGetChallengesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>> = ({ signal }) => userKYCControllerGetChallenges(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserKYCControllerGetChallengesQueryResult = NonNullable<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>>
export type UserKYCControllerGetChallengesQueryError = unknown


export function useUserKYCControllerGetChallenges<TData = Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userKYCControllerGetChallenges>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserKYCControllerGetChallenges<TData = Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userKYCControllerGetChallenges>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserKYCControllerGetChallenges<TData = Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserKYCControllerGetChallenges<TData = Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userKYCControllerGetChallenges>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserKYCControllerGetChallengesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userKYCControllerChallengeKyc = (
    challengeId: number,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<Kycdto>(
      {url: `/user/kyc/${challengeId}`, method: 'POST', signal
    },
      options);
    }
  


export const getUserKYCControllerChallengeKycMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>, TError,{challengeId: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>, {challengeId: number}> = (props) => {
          const {challengeId} = props ?? {};

          return  userKYCControllerChallengeKyc(challengeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserKYCControllerChallengeKycMutationResult = NonNullable<Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>>
    
    export type UserKYCControllerChallengeKycMutationError = unknown

    export const useUserKYCControllerChallengeKyc = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>, TError,{challengeId: number}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userKYCControllerChallengeKyc>>,
        TError,
        {challengeId: number},
        TContext
      > => {

      const mutationOptions = getUserKYCControllerChallengeKycMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userBeneficiaryControllerUpdateBeneficiary = (
    updateBeneficiaryDTO: UpdateBeneficiaryDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<BeneficiaryDTO>(
      {url: `/user/beneficiary`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateBeneficiaryDTO
    },
      options);
    }
  


export const getUserBeneficiaryControllerUpdateBeneficiaryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>, TError,{data: UpdateBeneficiaryDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>, TError,{data: UpdateBeneficiaryDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>, {data: UpdateBeneficiaryDTO}> = (props) => {
          const {data} = props ?? {};

          return  userBeneficiaryControllerUpdateBeneficiary(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserBeneficiaryControllerUpdateBeneficiaryMutationResult = NonNullable<Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>>
    export type UserBeneficiaryControllerUpdateBeneficiaryMutationBody = UpdateBeneficiaryDTO
    export type UserBeneficiaryControllerUpdateBeneficiaryMutationError = unknown

    export const useUserBeneficiaryControllerUpdateBeneficiary = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>, TError,{data: UpdateBeneficiaryDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userBeneficiaryControllerUpdateBeneficiary>>,
        TError,
        {data: UpdateBeneficiaryDTO},
        TContext
      > => {

      const mutationOptions = getUserBeneficiaryControllerUpdateBeneficiaryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userBeneficiaryControllerUploadDocument = (
    userBeneficiaryControllerUploadDocumentBody: UserBeneficiaryControllerUploadDocumentBody,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(userBeneficiaryControllerUploadDocumentBody.file !== undefined) {
 formData.append('file', userBeneficiaryControllerUploadDocumentBody.file)
 }

      return clientInstance<SuccessDTO>(
      {url: `/user/beneficiary/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getUserBeneficiaryControllerUploadDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>, TError,{data: UserBeneficiaryControllerUploadDocumentBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>, TError,{data: UserBeneficiaryControllerUploadDocumentBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>, {data: UserBeneficiaryControllerUploadDocumentBody}> = (props) => {
          const {data} = props ?? {};

          return  userBeneficiaryControllerUploadDocument(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserBeneficiaryControllerUploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>>
    export type UserBeneficiaryControllerUploadDocumentMutationBody = UserBeneficiaryControllerUploadDocumentBody
    export type UserBeneficiaryControllerUploadDocumentMutationError = unknown

    export const useUserBeneficiaryControllerUploadDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>, TError,{data: UserBeneficiaryControllerUploadDocumentBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userBeneficiaryControllerUploadDocument>>,
        TError,
        {data: UserBeneficiaryControllerUploadDocumentBody},
        TContext
      > => {

      const mutationOptions = getUserBeneficiaryControllerUploadDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userPayoutControllerGetPayout = (
    payoutId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<UserPayoutDTO>(
      {url: `/user/payout/${payoutId}`, method: 'GET', signal
    },
      options);
    }
  

export const getUserPayoutControllerGetPayoutQueryKey = (payoutId: string,) => {
    return [`/user/payout/${payoutId}`] as const;
    }

    
export const getUserPayoutControllerGetPayoutQueryOptions = <TData = Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError = unknown>(payoutId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserPayoutControllerGetPayoutQueryKey(payoutId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>> = ({ signal }) => userPayoutControllerGetPayout(payoutId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(payoutId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type UserPayoutControllerGetPayoutQueryResult = NonNullable<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>>
export type UserPayoutControllerGetPayoutQueryError = unknown


export function useUserPayoutControllerGetPayout<TData = Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError = unknown>(
 payoutId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPayoutControllerGetPayout>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserPayoutControllerGetPayout<TData = Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError = unknown>(
 payoutId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPayoutControllerGetPayout>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useUserPayoutControllerGetPayout<TData = Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError = unknown>(
 payoutId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useUserPayoutControllerGetPayout<TData = Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError = unknown>(
 payoutId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPayoutControllerGetPayout>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getUserPayoutControllerGetPayoutQueryOptions(payoutId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userPayoutControllerCreatePayout = (
    userCreatePayoutDTO: UserCreatePayoutDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<UserPayoutDTO>(
      {url: `/user/payout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreatePayoutDTO, signal
    },
      options);
    }
  


export const getUserPayoutControllerCreatePayoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>, TError,{data: UserCreatePayoutDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>, TError,{data: UserCreatePayoutDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>, {data: UserCreatePayoutDTO}> = (props) => {
          const {data} = props ?? {};

          return  userPayoutControllerCreatePayout(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserPayoutControllerCreatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>>
    export type UserPayoutControllerCreatePayoutMutationBody = UserCreatePayoutDTO
    export type UserPayoutControllerCreatePayoutMutationError = unknown

    export const useUserPayoutControllerCreatePayout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>, TError,{data: UserCreatePayoutDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userPayoutControllerCreatePayout>>,
        TError,
        {data: UserCreatePayoutDTO},
        TContext
      > => {

      const mutationOptions = getUserPayoutControllerCreatePayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userPayoutControllerConfirmPayout = (
    payoutId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<UserPayoutDTO>(
      {url: `/user/payout/${payoutId}/confirm`, method: 'PATCH'
    },
      options);
    }
  


export const getUserPayoutControllerConfirmPayoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>, TError,{payoutId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>, TError,{payoutId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>, {payoutId: string}> = (props) => {
          const {payoutId} = props ?? {};

          return  userPayoutControllerConfirmPayout(payoutId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserPayoutControllerConfirmPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>>
    
    export type UserPayoutControllerConfirmPayoutMutationError = unknown

    export const useUserPayoutControllerConfirmPayout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>, TError,{payoutId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userPayoutControllerConfirmPayout>>,
        TError,
        {payoutId: string},
        TContext
      > => {

      const mutationOptions = getUserPayoutControllerConfirmPayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userPayoutControllerCancelPayout = (
    payoutId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/user/payout/${payoutId}/cancel`, method: 'PATCH'
    },
      options);
    }
  


export const getUserPayoutControllerCancelPayoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>, TError,{payoutId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>, TError,{payoutId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>, {payoutId: string}> = (props) => {
          const {payoutId} = props ?? {};

          return  userPayoutControllerCancelPayout(payoutId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserPayoutControllerCancelPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>>
    
    export type UserPayoutControllerCancelPayoutMutationError = unknown

    export const useUserPayoutControllerCancelPayout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>, TError,{payoutId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof userPayoutControllerCancelPayout>>,
        TError,
        {payoutId: string},
        TContext
      > => {

      const mutationOptions = getUserPayoutControllerCancelPayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const stripeConnectKYCControllerStatus = (
    stripeConnecTokenDTO: StripeConnecTokenDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<StripeConnectStatusDTO>(
      {url: `/stripeconnect/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripeConnecTokenDTO, signal
    },
      options);
    }
  


export const getStripeConnectKYCControllerStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>, TError,{data: StripeConnecTokenDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>, TError,{data: StripeConnecTokenDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>, {data: StripeConnecTokenDTO}> = (props) => {
          const {data} = props ?? {};

          return  stripeConnectKYCControllerStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StripeConnectKYCControllerStatusMutationResult = NonNullable<Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>>
    export type StripeConnectKYCControllerStatusMutationBody = StripeConnecTokenDTO
    export type StripeConnectKYCControllerStatusMutationError = unknown

    export const useStripeConnectKYCControllerStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>, TError,{data: StripeConnecTokenDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof stripeConnectKYCControllerStatus>>,
        TError,
        {data: StripeConnecTokenDTO},
        TContext
      > => {

      const mutationOptions = getStripeConnectKYCControllerStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const stripeConnectKYCControllerSession = (
    stripeConnecTokenDTO: StripeConnecTokenDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<StripeConnecTokenDTO>(
      {url: `/stripeconnect/session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stripeConnecTokenDTO, signal
    },
      options);
    }
  


export const getStripeConnectKYCControllerSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>, TError,{data: StripeConnecTokenDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>, TError,{data: StripeConnecTokenDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>, {data: StripeConnecTokenDTO}> = (props) => {
          const {data} = props ?? {};

          return  stripeConnectKYCControllerSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StripeConnectKYCControllerSessionMutationResult = NonNullable<Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>>
    export type StripeConnectKYCControllerSessionMutationBody = StripeConnecTokenDTO
    export type StripeConnectKYCControllerSessionMutationError = unknown

    export const useStripeConnectKYCControllerSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>, TError,{data: StripeConnecTokenDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof stripeConnectKYCControllerSession>>,
        TError,
        {data: StripeConnecTokenDTO},
        TContext
      > => {

      const mutationOptions = getStripeConnectKYCControllerSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationControllerList = (
    
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationDTO[]>(
      {url: `/organization`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerListQueryKey = () => {
    return [`/organization`] as const;
    }

    
export const getOrganizationControllerListQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerList>>> = ({ signal }) => organizationControllerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerList>>>
export type OrganizationControllerListQueryError = unknown


export function useOrganizationControllerList<TData = Awaited<ReturnType<typeof organizationControllerList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationControllerList<TData = Awaited<ReturnType<typeof organizationControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationControllerList<TData = Awaited<ReturnType<typeof organizationControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationControllerList<TData = Awaited<ReturnType<typeof organizationControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationControllerListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerCreate = (
    createOrganizationDTO: CreateOrganizationDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationDTO>(
      {url: `/organization`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationDTO, signal
    },
      options);
    }
  


export const getOrganizationControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerCreate>>, {data: CreateOrganizationDTO}> = (props) => {
          const {data} = props ?? {};

          return  organizationControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerCreate>>>
    export type OrganizationControllerCreateMutationBody = CreateOrganizationDTO
    export type OrganizationControllerCreateMutationError = unknown

    export const useOrganizationControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerCreate>>, TError,{data: CreateOrganizationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerCreate>>,
        TError,
        {data: CreateOrganizationDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationControllerFindOne = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationDTO>(
      {url: `/organization/${organizationId}`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationControllerFindOneQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}`] as const;
    }

    
export const getOrganizationControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationControllerFindOneQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationControllerFindOne>>> = ({ signal }) => organizationControllerFindOne(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof organizationControllerFindOne>>>
export type OrganizationControllerFindOneQueryError = unknown


export function useOrganizationControllerFindOne<TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationControllerFindOne>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationControllerFindOne<TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationControllerFindOne>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationControllerFindOne<TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationControllerFindOne<TData = Awaited<ReturnType<typeof organizationControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationControllerFindOneQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationControllerUpdate = (
    organizationId: string,
    updateOrganizationDTO: UpdateOrganizationDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<OrganizationDTO>(
      {url: `/organization/${organizationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationDTO
    },
      options);
    }
  


export const getOrganizationControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{organizationId: string;data: UpdateOrganizationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{organizationId: string;data: UpdateOrganizationDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUpdate>>, {organizationId: string;data: UpdateOrganizationDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationControllerUpdate(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUpdate>>>
    export type OrganizationControllerUpdateMutationBody = UpdateOrganizationDTO
    export type OrganizationControllerUpdateMutationError = unknown

    export const useOrganizationControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUpdate>>, TError,{organizationId: string;data: UpdateOrganizationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUpdate>>,
        TError,
        {organizationId: string;data: UpdateOrganizationDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationControllerDelete = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrganizationControllerDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDelete>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDelete>>, TError,{organizationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerDelete>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  organizationControllerDelete(organizationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerDelete>>>
    
    export type OrganizationControllerDeleteMutationError = unknown

    export const useOrganizationControllerDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerDelete>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerDelete>>,
        TError,
        {organizationId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationControllerUploadAvatar = (
    organizationId: string,
    type: string,
    organizationControllerUploadAvatarBody: OrganizationControllerUploadAvatarBody,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(organizationControllerUploadAvatarBody.file !== undefined) {
 formData.append('file', organizationControllerUploadAvatarBody.file)
 }

      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/upload/${type}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getOrganizationControllerUploadAvatarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUploadAvatar>>, TError,{organizationId: string;type: string;data: OrganizationControllerUploadAvatarBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUploadAvatar>>, TError,{organizationId: string;type: string;data: OrganizationControllerUploadAvatarBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationControllerUploadAvatar>>, {organizationId: string;type: string;data: OrganizationControllerUploadAvatarBody}> = (props) => {
          const {organizationId,type,data} = props ?? {};

          return  organizationControllerUploadAvatar(organizationId,type,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationControllerUploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof organizationControllerUploadAvatar>>>
    export type OrganizationControllerUploadAvatarMutationBody = OrganizationControllerUploadAvatarBody
    export type OrganizationControllerUploadAvatarMutationError = unknown

    export const useOrganizationControllerUploadAvatar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationControllerUploadAvatar>>, TError,{organizationId: string;type: string;data: OrganizationControllerUploadAvatarBody}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationControllerUploadAvatar>>,
        TError,
        {organizationId: string;type: string;data: OrganizationControllerUploadAvatarBody},
        TContext
      > => {

      const mutationOptions = getOrganizationControllerUploadAvatarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationLinksControllerGetInvitationLink = (
    organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<LinkDTO>(
      {url: `/organization/${organizationId}/link`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getOrganizationLinksControllerGetInvitationLinkQueryKey = (organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams,) => {
    return [`/organization/${organizationId}/link`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationLinksControllerGetInvitationLinkQueryOptions = <TData = Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError = unknown>(organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationLinksControllerGetInvitationLinkQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>> = ({ signal }) => organizationLinksControllerGetInvitationLink(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationLinksControllerGetInvitationLinkQueryResult = NonNullable<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>>
export type OrganizationLinksControllerGetInvitationLinkQueryError = unknown


export function useOrganizationLinksControllerGetInvitationLink<TData = Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError = unknown>(
 organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationLinksControllerGetInvitationLink<TData = Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError = unknown>(
 organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationLinksControllerGetInvitationLink<TData = Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError = unknown>(
 organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationLinksControllerGetInvitationLink<TData = Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError = unknown>(
 organizationId: string,
    params: OrganizationLinksControllerGetInvitationLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationLinksControllerGetInvitationLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationLinksControllerGetInvitationLinkQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationLinksControllerSendInvitations = (
    organizationId: string,
    sendInvitationDTO: SendInvitationDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendInvitationDTO, signal
    },
      options);
    }
  


export const getOrganizationLinksControllerSendInvitationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>, TError,{organizationId: string;data: SendInvitationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>, TError,{organizationId: string;data: SendInvitationDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>, {organizationId: string;data: SendInvitationDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationLinksControllerSendInvitations(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationLinksControllerSendInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>>
    export type OrganizationLinksControllerSendInvitationsMutationBody = SendInvitationDTO
    export type OrganizationLinksControllerSendInvitationsMutationError = unknown

    export const useOrganizationLinksControllerSendInvitations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>, TError,{organizationId: string;data: SendInvitationDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationLinksControllerSendInvitations>>,
        TError,
        {organizationId: string;data: SendInvitationDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationLinksControllerSendInvitationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationParticipantsControllerFindAll = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<ParticipantDTO[]>(
      {url: `/organization/${organizationId}/participant`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationParticipantsControllerFindAllQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}/participant`] as const;
    }

    
export const getOrganizationParticipantsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationParticipantsControllerFindAllQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>> = ({ signal }) => organizationParticipantsControllerFindAll(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationParticipantsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>>
export type OrganizationParticipantsControllerFindAllQueryError = unknown


export function useOrganizationParticipantsControllerFindAll<TData = Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationParticipantsControllerFindAll<TData = Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationParticipantsControllerFindAll<TData = Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationParticipantsControllerFindAll<TData = Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParticipantsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationParticipantsControllerFindAllQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationParticipantsControllerUpdate = (
    organizationId: string,
    participantId: string,
    updateParticipantDTO: UpdateParticipantDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<ParticipantDTO>(
      {url: `/organization/${organizationId}/participant/${participantId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateParticipantDTO
    },
      options);
    }
  


export const getOrganizationParticipantsControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>, TError,{organizationId: string;participantId: string;data: UpdateParticipantDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>, TError,{organizationId: string;participantId: string;data: UpdateParticipantDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>, {organizationId: string;participantId: string;data: UpdateParticipantDTO}> = (props) => {
          const {organizationId,participantId,data} = props ?? {};

          return  organizationParticipantsControllerUpdate(organizationId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationParticipantsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>>
    export type OrganizationParticipantsControllerUpdateMutationBody = UpdateParticipantDTO
    export type OrganizationParticipantsControllerUpdateMutationError = unknown

    export const useOrganizationParticipantsControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>, TError,{organizationId: string;participantId: string;data: UpdateParticipantDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationParticipantsControllerUpdate>>,
        TError,
        {organizationId: string;participantId: string;data: UpdateParticipantDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationParticipantsControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationParticipantsControllerDelete = (
    organizationId: string,
    participantId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/participant/${participantId}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrganizationParticipantsControllerDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>, TError,{organizationId: string;participantId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>, TError,{organizationId: string;participantId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>, {organizationId: string;participantId: string}> = (props) => {
          const {organizationId,participantId} = props ?? {};

          return  organizationParticipantsControllerDelete(organizationId,participantId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationParticipantsControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>>
    
    export type OrganizationParticipantsControllerDeleteMutationError = unknown

    export const useOrganizationParticipantsControllerDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>, TError,{organizationId: string;participantId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationParticipantsControllerDelete>>,
        TError,
        {organizationId: string;participantId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationParticipantsControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationTagsControllerGetTags = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<TagDTO>(
      {url: `/organization/${organizationId}/tag`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationTagsControllerGetTagsQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}/tag`] as const;
    }

    
export const getOrganizationTagsControllerGetTagsQueryOptions = <TData = Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationTagsControllerGetTagsQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>> = ({ signal }) => organizationTagsControllerGetTags(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationTagsControllerGetTagsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>>
export type OrganizationTagsControllerGetTagsQueryError = unknown


export function useOrganizationTagsControllerGetTags<TData = Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationTagsControllerGetTags>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationTagsControllerGetTags<TData = Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationTagsControllerGetTags>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationTagsControllerGetTags<TData = Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationTagsControllerGetTags<TData = Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationTagsControllerGetTags>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationTagsControllerGetTagsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationInviteControllerFindOrganization = (
    token: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationByInvitationDTO>(
      {url: `/invitation/${token}`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationInviteControllerFindOrganizationQueryKey = (token: string,) => {
    return [`/invitation/${token}`] as const;
    }

    
export const getOrganizationInviteControllerFindOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationInviteControllerFindOrganizationQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>> = ({ signal }) => organizationInviteControllerFindOrganization(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationInviteControllerFindOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>>
export type OrganizationInviteControllerFindOrganizationQueryError = unknown


export function useOrganizationInviteControllerFindOrganization<TData = Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationInviteControllerFindOrganization<TData = Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationInviteControllerFindOrganization<TData = Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationInviteControllerFindOrganization<TData = Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationInviteControllerFindOrganizationQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const organizationInviteControllerAcceptInvitation = (
    token: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<ParticipantDTO>(
      {url: `/invitation/${token}`, method: 'PUT'
    },
      options);
    }
  


export const getOrganizationInviteControllerAcceptInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>, TError,{token: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  organizationInviteControllerAcceptInvitation(token,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationInviteControllerAcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>>
    
    export type OrganizationInviteControllerAcceptInvitationMutationError = unknown

    export const useOrganizationInviteControllerAcceptInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof organizationInviteControllerAcceptInvitation>>,
        TError,
        {token: string},
        TContext
      > => {

      const mutationOptions = getOrganizationInviteControllerAcceptInvitationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const organizationInviteControllerGenerateMagicLink = (
    token: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<GetMagicLinkDTO>(
      {url: `/invitation/${token}/magic-link`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationInviteControllerGenerateMagicLinkQueryKey = (token: string,) => {
    return [`/invitation/${token}/magic-link`] as const;
    }

    
export const getOrganizationInviteControllerGenerateMagicLinkQueryOptions = <TData = Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationInviteControllerGenerateMagicLinkQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>> = ({ signal }) => organizationInviteControllerGenerateMagicLink(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrganizationInviteControllerGenerateMagicLinkQueryResult = NonNullable<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>>
export type OrganizationInviteControllerGenerateMagicLinkQueryError = unknown


export function useOrganizationInviteControllerGenerateMagicLink<TData = Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationInviteControllerGenerateMagicLink<TData = Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrganizationInviteControllerGenerateMagicLink<TData = Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrganizationInviteControllerGenerateMagicLink<TData = Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationInviteControllerGenerateMagicLink>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrganizationInviteControllerGenerateMagicLinkQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const invitationCodeControllerRegenerateInvitationCode = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<InvitationCodeDTO>(
      {url: `/organization/${organizationId}/invitation-code`, method: 'POST', signal
    },
      options);
    }
  


export const getInvitationCodeControllerRegenerateInvitationCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>, TError,{organizationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  invitationCodeControllerRegenerateInvitationCode(organizationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationCodeControllerRegenerateInvitationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>>
    
    export type InvitationCodeControllerRegenerateInvitationCodeMutationError = unknown

    export const useInvitationCodeControllerRegenerateInvitationCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof invitationCodeControllerRegenerateInvitationCode>>,
        TError,
        {organizationId: string},
        TContext
      > => {

      const mutationOptions = getInvitationCodeControllerRegenerateInvitationCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const joinByCodeControllerFindOrganization = (
    code: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationByCodeDTO>(
      {url: `/join/${code}`, method: 'GET', signal
    },
      options);
    }
  

export const getJoinByCodeControllerFindOrganizationQueryKey = (code: string,) => {
    return [`/join/${code}`] as const;
    }

    
export const getJoinByCodeControllerFindOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJoinByCodeControllerFindOrganizationQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>> = ({ signal }) => joinByCodeControllerFindOrganization(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type JoinByCodeControllerFindOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>>
export type JoinByCodeControllerFindOrganizationQueryError = unknown


export function useJoinByCodeControllerFindOrganization<TData = Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useJoinByCodeControllerFindOrganization<TData = Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useJoinByCodeControllerFindOrganization<TData = Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useJoinByCodeControllerFindOrganization<TData = Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinByCodeControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getJoinByCodeControllerFindOrganizationQueryOptions(code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const joinByCodeControllerJoinByCode = (
    code: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<ParticipantDTO>(
      {url: `/join/${code}`, method: 'PUT'
    },
      options);
    }
  


export const getJoinByCodeControllerJoinByCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>, TError,{code: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>, {code: string}> = (props) => {
          const {code} = props ?? {};

          return  joinByCodeControllerJoinByCode(code,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinByCodeControllerJoinByCodeMutationResult = NonNullable<Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>>
    
    export type JoinByCodeControllerJoinByCodeMutationError = unknown

    export const useJoinByCodeControllerJoinByCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof joinByCodeControllerJoinByCode>>,
        TError,
        {code: string},
        TContext
      > => {

      const mutationOptions = getJoinByCodeControllerJoinByCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgWalletControllerTransfer = (
    organizationId: string,
    transactionPostingDTO: TransactionPostingDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/wallet/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transactionPostingDTO, signal
    },
      options);
    }
  


export const getOrgWalletControllerTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerTransfer>>, TError,{organizationId: string;data: TransactionPostingDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerTransfer>>, TError,{organizationId: string;data: TransactionPostingDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgWalletControllerTransfer>>, {organizationId: string;data: TransactionPostingDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  orgWalletControllerTransfer(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgWalletControllerTransferMutationResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerTransfer>>>
    export type OrgWalletControllerTransferMutationBody = TransactionPostingDTO
    export type OrgWalletControllerTransferMutationError = unknown

    export const useOrgWalletControllerTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerTransfer>>, TError,{organizationId: string;data: TransactionPostingDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgWalletControllerTransfer>>,
        TError,
        {organizationId: string;data: TransactionPostingDTO},
        TContext
      > => {

      const mutationOptions = getOrgWalletControllerTransferMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgWalletControllerList = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<WalletDTO[]>(
      {url: `/organization/${organizationId}/wallet`, method: 'GET', signal
    },
      options);
    }
  

export const getOrgWalletControllerListQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}/wallet`] as const;
    }

    
export const getOrgWalletControllerListQueryOptions = <TData = Awaited<ReturnType<typeof orgWalletControllerList>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrgWalletControllerListQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof orgWalletControllerList>>> = ({ signal }) => orgWalletControllerList(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrgWalletControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerList>>>
export type OrgWalletControllerListQueryError = unknown


export function useOrgWalletControllerList<TData = Awaited<ReturnType<typeof orgWalletControllerList>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerList<TData = Awaited<ReturnType<typeof orgWalletControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerList<TData = Awaited<ReturnType<typeof orgWalletControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrgWalletControllerList<TData = Awaited<ReturnType<typeof orgWalletControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrgWalletControllerListQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const orgWalletControllerCreate = (
    organizationId: string,
    createOrganizationWalletDTO: CreateOrganizationWalletDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<WalletDTO[]>(
      {url: `/organization/${organizationId}/wallet`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationWalletDTO, signal
    },
      options);
    }
  


export const getOrgWalletControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationWalletDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationWalletDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgWalletControllerCreate>>, {organizationId: string;data: CreateOrganizationWalletDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  orgWalletControllerCreate(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgWalletControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerCreate>>>
    export type OrgWalletControllerCreateMutationBody = CreateOrganizationWalletDTO
    export type OrgWalletControllerCreateMutationError = unknown

    export const useOrgWalletControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationWalletDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgWalletControllerCreate>>,
        TError,
        {organizationId: string;data: CreateOrganizationWalletDTO},
        TContext
      > => {

      const mutationOptions = getOrgWalletControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgWalletControllerUpdate = (
    organizationId: string,
    walletId: string,
    updateOrganizationWalletDTO: UpdateOrganizationWalletDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<WalletDTO[]>(
      {url: `/organization/${organizationId}/wallet/${walletId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationWalletDTO
    },
      options);
    }
  


export const getOrgWalletControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerUpdate>>, TError,{organizationId: string;walletId: string;data: UpdateOrganizationWalletDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerUpdate>>, TError,{organizationId: string;walletId: string;data: UpdateOrganizationWalletDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgWalletControllerUpdate>>, {organizationId: string;walletId: string;data: UpdateOrganizationWalletDTO}> = (props) => {
          const {organizationId,walletId,data} = props ?? {};

          return  orgWalletControllerUpdate(organizationId,walletId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgWalletControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerUpdate>>>
    export type OrgWalletControllerUpdateMutationBody = UpdateOrganizationWalletDTO
    export type OrgWalletControllerUpdateMutationError = unknown

    export const useOrgWalletControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerUpdate>>, TError,{organizationId: string;walletId: string;data: UpdateOrganizationWalletDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgWalletControllerUpdate>>,
        TError,
        {organizationId: string;walletId: string;data: UpdateOrganizationWalletDTO},
        TContext
      > => {

      const mutationOptions = getOrgWalletControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgWalletControllerDelete = (
    organizationId: string,
    walletId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/wallet/${walletId}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrgWalletControllerDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerDelete>>, TError,{organizationId: string;walletId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerDelete>>, TError,{organizationId: string;walletId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgWalletControllerDelete>>, {organizationId: string;walletId: string}> = (props) => {
          const {organizationId,walletId} = props ?? {};

          return  orgWalletControllerDelete(organizationId,walletId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgWalletControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerDelete>>>
    
    export type OrgWalletControllerDeleteMutationError = unknown

    export const useOrgWalletControllerDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgWalletControllerDelete>>, TError,{organizationId: string;walletId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgWalletControllerDelete>>,
        TError,
        {organizationId: string;walletId: string},
        TContext
      > => {

      const mutationOptions = getOrgWalletControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgWalletControllerGetTransactionsCSV = (
    organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<void>(
      {url: `/organization/${organizationId}/wallet/transactions/csv`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getOrgWalletControllerGetTransactionsCSVQueryKey = (organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams,) => {
    return [`/organization/${organizationId}/wallet/transactions/csv`, ...(params ? [params]: [])] as const;
    }

    
export const getOrgWalletControllerGetTransactionsCSVQueryOptions = <TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError = unknown>(organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrgWalletControllerGetTransactionsCSVQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>> = ({ signal }) => orgWalletControllerGetTransactionsCSV(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrgWalletControllerGetTransactionsCSVQueryResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>>
export type OrgWalletControllerGetTransactionsCSVQueryError = unknown


export function useOrgWalletControllerGetTransactionsCSV<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError = unknown>(
 organizationId: string,
    params: undefined |  OrgWalletControllerGetTransactionsCSVParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerGetTransactionsCSV<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError = unknown>(
 organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerGetTransactionsCSV<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError = unknown>(
 organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrgWalletControllerGetTransactionsCSV<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError = unknown>(
 organizationId: string,
    params?: OrgWalletControllerGetTransactionsCSVParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactionsCSV>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrgWalletControllerGetTransactionsCSVQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const orgWalletControllerGetTransactions = (
    organizationId: string,
    params: OrgWalletControllerGetTransactionsParams,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrgTransactionResponseDTO>(
      {url: `/organization/${organizationId}/wallet/transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getOrgWalletControllerGetTransactionsQueryKey = (organizationId: string,
    params: OrgWalletControllerGetTransactionsParams,) => {
    return [`/organization/${organizationId}/wallet/transactions`, ...(params ? [params]: [])] as const;
    }

    
export const getOrgWalletControllerGetTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError = unknown>(organizationId: string,
    params: OrgWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrgWalletControllerGetTransactionsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>> = ({ signal }) => orgWalletControllerGetTransactions(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrgWalletControllerGetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>>
export type OrgWalletControllerGetTransactionsQueryError = unknown


export function useOrgWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError = unknown>(
 organizationId: string,
    params: OrgWalletControllerGetTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError = unknown>(
 organizationId: string,
    params: OrgWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError = unknown>(
 organizationId: string,
    params: OrgWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrgWalletControllerGetTransactions<TData = Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError = unknown>(
 organizationId: string,
    params: OrgWalletControllerGetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgWalletControllerGetTransactions>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrgWalletControllerGetTransactionsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const orgQRControllerList = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationQRDTO[]>(
      {url: `/organization/${organizationId}/qr`, method: 'GET', signal
    },
      options);
    }
  

export const getOrgQRControllerListQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}/qr`] as const;
    }

    
export const getOrgQRControllerListQueryOptions = <TData = Awaited<ReturnType<typeof orgQRControllerList>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrgQRControllerListQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof orgQRControllerList>>> = ({ signal }) => orgQRControllerList(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrgQRControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof orgQRControllerList>>>
export type OrgQRControllerListQueryError = unknown


export function useOrgQRControllerList<TData = Awaited<ReturnType<typeof orgQRControllerList>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgQRControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgQRControllerList<TData = Awaited<ReturnType<typeof orgQRControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgQRControllerList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgQRControllerList<TData = Awaited<ReturnType<typeof orgQRControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrgQRControllerList<TData = Awaited<ReturnType<typeof orgQRControllerList>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgQRControllerList>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrgQRControllerListQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const orgQRControllerCreate = (
    organizationId: string,
    createOrganizationQRDTO: CreateOrganizationQRDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<OrganizationQRDTO>(
      {url: `/organization/${organizationId}/qr`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationQRDTO, signal
    },
      options);
    }
  


export const getOrgQRControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationQRDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationQRDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgQRControllerCreate>>, {organizationId: string;data: CreateOrganizationQRDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  orgQRControllerCreate(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgQRControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof orgQRControllerCreate>>>
    export type OrgQRControllerCreateMutationBody = CreateOrganizationQRDTO
    export type OrgQRControllerCreateMutationError = unknown

    export const useOrgQRControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerCreate>>, TError,{organizationId: string;data: CreateOrganizationQRDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgQRControllerCreate>>,
        TError,
        {organizationId: string;data: CreateOrganizationQRDTO},
        TContext
      > => {

      const mutationOptions = getOrgQRControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgQRControllerUpdate = (
    organizationId: string,
    qrId: string,
    updateOrganizationQRDTO: UpdateOrganizationQRDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<OrganizationQRDTO>(
      {url: `/organization/${organizationId}/qr/${qrId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationQRDTO
    },
      options);
    }
  


export const getOrgQRControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerUpdate>>, TError,{organizationId: string;qrId: string;data: UpdateOrganizationQRDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerUpdate>>, TError,{organizationId: string;qrId: string;data: UpdateOrganizationQRDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgQRControllerUpdate>>, {organizationId: string;qrId: string;data: UpdateOrganizationQRDTO}> = (props) => {
          const {organizationId,qrId,data} = props ?? {};

          return  orgQRControllerUpdate(organizationId,qrId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgQRControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof orgQRControllerUpdate>>>
    export type OrgQRControllerUpdateMutationBody = UpdateOrganizationQRDTO
    export type OrgQRControllerUpdateMutationError = unknown

    export const useOrgQRControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerUpdate>>, TError,{organizationId: string;qrId: string;data: UpdateOrganizationQRDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgQRControllerUpdate>>,
        TError,
        {organizationId: string;qrId: string;data: UpdateOrganizationQRDTO},
        TContext
      > => {

      const mutationOptions = getOrgQRControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgQRControllerDelete = (
    organizationId: string,
    qrId: string,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<SuccessDTO>(
      {url: `/organization/${organizationId}/qr/${qrId}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrgQRControllerDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerDelete>>, TError,{organizationId: string;qrId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerDelete>>, TError,{organizationId: string;qrId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgQRControllerDelete>>, {organizationId: string;qrId: string}> = (props) => {
          const {organizationId,qrId} = props ?? {};

          return  orgQRControllerDelete(organizationId,qrId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgQRControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof orgQRControllerDelete>>>
    
    export type OrgQRControllerDeleteMutationError = unknown

    export const useOrgQRControllerDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgQRControllerDelete>>, TError,{organizationId: string;qrId: string}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgQRControllerDelete>>,
        TError,
        {organizationId: string;qrId: string},
        TContext
      > => {

      const mutationOptions = getOrgQRControllerDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const orgPaymentRuleControllerFindOne = (
    organizationId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<PaymentRuletDTO>(
      {url: `/organization/${organizationId}/rule`, method: 'GET', signal
    },
      options);
    }
  

export const getOrgPaymentRuleControllerFindOneQueryKey = (organizationId: string,) => {
    return [`/organization/${organizationId}/rule`] as const;
    }

    
export const getOrgPaymentRuleControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError = unknown>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrgPaymentRuleControllerFindOneQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>> = ({ signal }) => orgPaymentRuleControllerFindOne(organizationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OrgPaymentRuleControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>>
export type OrgPaymentRuleControllerFindOneQueryError = unknown


export function useOrgPaymentRuleControllerFindOne<TData = Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError = unknown>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgPaymentRuleControllerFindOne<TData = Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOrgPaymentRuleControllerFindOne<TData = Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useOrgPaymentRuleControllerFindOne<TData = Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError = unknown>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOrgPaymentRuleControllerFindOneQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const orgPaymentRuleControllerUpdate = (
    organizationId: string,
    setPaymentRuleDTO: SetPaymentRuleDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<PaymentRuletDTO>(
      {url: `/organization/${organizationId}/rule`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setPaymentRuleDTO
    },
      options);
    }
  


export const getOrgPaymentRuleControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>, TError,{organizationId: string;data: SetPaymentRuleDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>, TError,{organizationId: string;data: SetPaymentRuleDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>, {organizationId: string;data: SetPaymentRuleDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  orgPaymentRuleControllerUpdate(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrgPaymentRuleControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>>
    export type OrgPaymentRuleControllerUpdateMutationBody = SetPaymentRuleDTO
    export type OrgPaymentRuleControllerUpdateMutationError = unknown

    export const useOrgPaymentRuleControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>, TError,{organizationId: string;data: SetPaymentRuleDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof orgPaymentRuleControllerUpdate>>,
        TError,
        {organizationId: string;data: SetPaymentRuleDTO},
        TContext
      > => {

      const mutationOptions = getOrgPaymentRuleControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const pageControllerFindQR = (
    qrNumber: number,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<PageQRDTO>(
      {url: `/page/qr/${qrNumber}`, method: 'GET', signal
    },
      options);
    }
  

export const getPageControllerFindQRQueryKey = (qrNumber: number,) => {
    return [`/page/qr/${qrNumber}`] as const;
    }

    
export const getPageControllerFindQRQueryOptions = <TData = Awaited<ReturnType<typeof pageControllerFindQR>>, TError = unknown>(qrNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPageControllerFindQRQueryKey(qrNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pageControllerFindQR>>> = ({ signal }) => pageControllerFindQR(qrNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(qrNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PageControllerFindQRQueryResult = NonNullable<Awaited<ReturnType<typeof pageControllerFindQR>>>
export type PageControllerFindQRQueryError = unknown


export function usePageControllerFindQR<TData = Awaited<ReturnType<typeof pageControllerFindQR>>, TError = unknown>(
 qrNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindQR>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindQR<TData = Awaited<ReturnType<typeof pageControllerFindQR>>, TError = unknown>(
 qrNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindQR>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindQR<TData = Awaited<ReturnType<typeof pageControllerFindQR>>, TError = unknown>(
 qrNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePageControllerFindQR<TData = Awaited<ReturnType<typeof pageControllerFindQR>>, TError = unknown>(
 qrNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindQR>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPageControllerFindQRQueryOptions(qrNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const pageControllerFindOrganization = (
    organizationNumber: number,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<PageOrganizationDTO>(
      {url: `/page/organization/${organizationNumber}`, method: 'GET', signal
    },
      options);
    }
  

export const getPageControllerFindOrganizationQueryKey = (organizationNumber: number,) => {
    return [`/page/organization/${organizationNumber}`] as const;
    }

    
export const getPageControllerFindOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError = unknown>(organizationNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPageControllerFindOrganizationQueryKey(organizationNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pageControllerFindOrganization>>> = ({ signal }) => pageControllerFindOrganization(organizationNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PageControllerFindOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof pageControllerFindOrganization>>>
export type PageControllerFindOrganizationQueryError = unknown


export function usePageControllerFindOrganization<TData = Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError = unknown>(
 organizationNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindOrganization<TData = Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError = unknown>(
 organizationNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindOrganization>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindOrganization<TData = Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError = unknown>(
 organizationNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePageControllerFindOrganization<TData = Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError = unknown>(
 organizationNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindOrganization>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPageControllerFindOrganizationQueryOptions(organizationNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const pageControllerFindParticipant = (
    participantNumber: number,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<PageParticipantDTO>(
      {url: `/page/participant/${participantNumber}`, method: 'GET', signal
    },
      options);
    }
  

export const getPageControllerFindParticipantQueryKey = (participantNumber: number,) => {
    return [`/page/participant/${participantNumber}`] as const;
    }

    
export const getPageControllerFindParticipantQueryOptions = <TData = Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError = unknown>(participantNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPageControllerFindParticipantQueryKey(participantNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pageControllerFindParticipant>>> = ({ signal }) => pageControllerFindParticipant(participantNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(participantNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PageControllerFindParticipantQueryResult = NonNullable<Awaited<ReturnType<typeof pageControllerFindParticipant>>>
export type PageControllerFindParticipantQueryError = unknown


export function usePageControllerFindParticipant<TData = Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError = unknown>(
 participantNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindParticipant>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindParticipant<TData = Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError = unknown>(
 participantNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pageControllerFindParticipant>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePageControllerFindParticipant<TData = Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError = unknown>(
 participantNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePageControllerFindParticipant<TData = Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError = unknown>(
 participantNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pageControllerFindParticipant>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPageControllerFindParticipantQueryOptions(participantNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const paymentControllerGetReceipt = (
    paymentId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<void>(
      {url: `/payment/${paymentId}/receipt`, method: 'GET', signal
    },
      options);
    }
  

export const getPaymentControllerGetReceiptQueryKey = (paymentId: string,) => {
    return [`/payment/${paymentId}/receipt`] as const;
    }

    
export const getPaymentControllerGetReceiptQueryOptions = <TData = Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError = unknown>(paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerGetReceiptQueryKey(paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerGetReceipt>>> = ({ signal }) => paymentControllerGetReceipt(paymentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PaymentControllerGetReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerGetReceipt>>>
export type PaymentControllerGetReceiptQueryError = unknown


export function usePaymentControllerGetReceipt<TData = Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError = unknown>(
 paymentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerGetReceipt>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePaymentControllerGetReceipt<TData = Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError = unknown>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerGetReceipt>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePaymentControllerGetReceipt<TData = Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError = unknown>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePaymentControllerGetReceipt<TData = Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError = unknown>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetReceipt>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPaymentControllerGetReceiptQueryOptions(paymentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const paymentControllerSendReceipt = (
    paymentId: string,
    sendReceiptDTO: SendReceiptDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<void>(
      {url: `/payment/${paymentId}/receipt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendReceiptDTO, signal
    },
      options);
    }
  


export const getPaymentControllerSendReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerSendReceipt>>, TError,{paymentId: string;data: SendReceiptDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerSendReceipt>>, TError,{paymentId: string;data: SendReceiptDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerSendReceipt>>, {paymentId: string;data: SendReceiptDTO}> = (props) => {
          const {paymentId,data} = props ?? {};

          return  paymentControllerSendReceipt(paymentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerSendReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerSendReceipt>>>
    export type PaymentControllerSendReceiptMutationBody = SendReceiptDTO
    export type PaymentControllerSendReceiptMutationError = unknown

    export const usePaymentControllerSendReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerSendReceipt>>, TError,{paymentId: string;data: SendReceiptDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerSendReceipt>>,
        TError,
        {paymentId: string;data: SendReceiptDTO},
        TContext
      > => {

      const mutationOptions = getPaymentControllerSendReceiptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const paymentControllerGetIntent = (
    intentId: string,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<IntentDetailsDTO>(
      {url: `/payment/intent/${intentId}`, method: 'GET', signal
    },
      options);
    }
  

export const getPaymentControllerGetIntentQueryKey = (intentId: string,) => {
    return [`/payment/intent/${intentId}`] as const;
    }

    
export const getPaymentControllerGetIntentQueryOptions = <TData = Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError = unknown>(intentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerGetIntentQueryKey(intentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerGetIntent>>> = ({ signal }) => paymentControllerGetIntent(intentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(intentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PaymentControllerGetIntentQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerGetIntent>>>
export type PaymentControllerGetIntentQueryError = unknown


export function usePaymentControllerGetIntent<TData = Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError = unknown>(
 intentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerGetIntent>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePaymentControllerGetIntent<TData = Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError = unknown>(
 intentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerGetIntent>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePaymentControllerGetIntent<TData = Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError = unknown>(
 intentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePaymentControllerGetIntent<TData = Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError = unknown>(
 intentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerGetIntent>>, TError, TData>>, request?: SecondParameter<typeof clientInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPaymentControllerGetIntentQueryOptions(intentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const paymentControllerConfirmIntent = (
    intentId: string,
    confirmIntentDTO: ConfirmIntentDTO,
 options?: SecondParameter<typeof clientInstance>,) => {
      
      
      return clientInstance<IntentProviderDTO>(
      {url: `/payment/intent/${intentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: confirmIntentDTO
    },
      options);
    }
  


export const getPaymentControllerConfirmIntentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerConfirmIntent>>, TError,{intentId: string;data: ConfirmIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerConfirmIntent>>, TError,{intentId: string;data: ConfirmIntentDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerConfirmIntent>>, {intentId: string;data: ConfirmIntentDTO}> = (props) => {
          const {intentId,data} = props ?? {};

          return  paymentControllerConfirmIntent(intentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerConfirmIntentMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerConfirmIntent>>>
    export type PaymentControllerConfirmIntentMutationBody = ConfirmIntentDTO
    export type PaymentControllerConfirmIntentMutationError = unknown

    export const usePaymentControllerConfirmIntent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerConfirmIntent>>, TError,{intentId: string;data: ConfirmIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerConfirmIntent>>,
        TError,
        {intentId: string;data: ConfirmIntentDTO},
        TContext
      > => {

      const mutationOptions = getPaymentControllerConfirmIntentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const paymentControllerCreateIntentByParticipant = (
    participantNumber: number,
    createIntentDTO: CreateIntentDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<IntentDTO>(
      {url: `/payment/participant/${participantNumber}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIntentDTO, signal
    },
      options);
    }
  


export const getPaymentControllerCreateIntentByParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>, TError,{participantNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>, TError,{participantNumber: number;data: CreateIntentDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>, {participantNumber: number;data: CreateIntentDTO}> = (props) => {
          const {participantNumber,data} = props ?? {};

          return  paymentControllerCreateIntentByParticipant(participantNumber,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerCreateIntentByParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>>
    export type PaymentControllerCreateIntentByParticipantMutationBody = CreateIntentDTO
    export type PaymentControllerCreateIntentByParticipantMutationError = unknown

    export const usePaymentControllerCreateIntentByParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>, TError,{participantNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerCreateIntentByParticipant>>,
        TError,
        {participantNumber: number;data: CreateIntentDTO},
        TContext
      > => {

      const mutationOptions = getPaymentControllerCreateIntentByParticipantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const paymentControllerCreateIntentByQr = (
    qrNumber: number,
    createIntentDTO: CreateIntentDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<IntentDTO>(
      {url: `/payment/qr/${qrNumber}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIntentDTO, signal
    },
      options);
    }
  


export const getPaymentControllerCreateIntentByQrMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>, TError,{qrNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>, TError,{qrNumber: number;data: CreateIntentDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>, {qrNumber: number;data: CreateIntentDTO}> = (props) => {
          const {qrNumber,data} = props ?? {};

          return  paymentControllerCreateIntentByQr(qrNumber,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerCreateIntentByQrMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>>
    export type PaymentControllerCreateIntentByQrMutationBody = CreateIntentDTO
    export type PaymentControllerCreateIntentByQrMutationError = unknown

    export const usePaymentControllerCreateIntentByQr = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>, TError,{qrNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerCreateIntentByQr>>,
        TError,
        {qrNumber: number;data: CreateIntentDTO},
        TContext
      > => {

      const mutationOptions = getPaymentControllerCreateIntentByQrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const paymentControllerCreateIntentByOrganization = (
    orgNumber: number,
    createIntentDTO: CreateIntentDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<IntentDTO>(
      {url: `/payment/organization/${orgNumber}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createIntentDTO, signal
    },
      options);
    }
  


export const getPaymentControllerCreateIntentByOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>, TError,{orgNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>, TError,{orgNumber: number;data: CreateIntentDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>, {orgNumber: number;data: CreateIntentDTO}> = (props) => {
          const {orgNumber,data} = props ?? {};

          return  paymentControllerCreateIntentByOrganization(orgNumber,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerCreateIntentByOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>>
    export type PaymentControllerCreateIntentByOrganizationMutationBody = CreateIntentDTO
    export type PaymentControllerCreateIntentByOrganizationMutationError = unknown

    export const usePaymentControllerCreateIntentByOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>, TError,{orgNumber: number;data: CreateIntentDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerCreateIntentByOrganization>>,
        TError,
        {orgNumber: number;data: CreateIntentDTO},
        TContext
      > => {

      const mutationOptions = getPaymentControllerCreateIntentByOrganizationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const feedbackControllerCreateFeedback = (
    createFeedbackDTO: CreateFeedbackDTO,
 options?: SecondParameter<typeof clientInstance>,signal?: AbortSignal
) => {
      
      
      return clientInstance<FeedbackDTO>(
      {url: `/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFeedbackDTO, signal
    },
      options);
    }
  


export const getFeedbackControllerCreateFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>, TError,{data: CreateFeedbackDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>, TError,{data: CreateFeedbackDTO}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>, {data: CreateFeedbackDTO}> = (props) => {
          const {data} = props ?? {};

          return  feedbackControllerCreateFeedback(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeedbackControllerCreateFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>>
    export type FeedbackControllerCreateFeedbackMutationBody = CreateFeedbackDTO
    export type FeedbackControllerCreateFeedbackMutationError = unknown

    export const useFeedbackControllerCreateFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>, TError,{data: CreateFeedbackDTO}, TContext>, request?: SecondParameter<typeof clientInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof feedbackControllerCreateFeedback>>,
        TError,
        {data: CreateFeedbackDTO},
        TContext
      > => {

      const mutationOptions = getFeedbackControllerCreateFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
